import StorageUtils from '@spothero/utils/storage';
import { StorageKeys } from 'common/constants/storageKeys';
// eslint-disable-next-line no-shadow
export var TotalPriceSessionPreference;
(function (TotalPriceSessionPreference) {
    TotalPriceSessionPreference["NotSelected"] = "not_selected";
    TotalPriceSessionPreference["On"] = "on";
    TotalPriceSessionPreference["Off"] = "off";
})(TotalPriceSessionPreference || (TotalPriceSessionPreference = {}));
export const persistTotalPriceSessionPreference = (value) => StorageUtils.set(StorageKeys.TOTAL_PRICE.TOTAL_PRICE_SESSION_PREFERENCE, value ? 'on' : 'off', StorageKeys.TOTAL_PRICE.TOTAL_PRICE_SESSION_PREFERENCE_STORAGE_TYPE);
export const getTotalPriceUserPreference = () => {
    const value = StorageUtils.get(StorageKeys.TOTAL_PRICE.TOTAL_PRICE_SESSION_PREFERENCE, StorageKeys.TOTAL_PRICE.TOTAL_PRICE_SESSION_PREFERENCE_STORAGE_TYPE);
    if (value === 'on') {
        return TotalPriceSessionPreference.On;
    }
    if (value === 'off') {
        return TotalPriceSessionPreference.Off;
    }
    return TotalPriceSessionPreference.NotSelected;
};
